import { Box, Typography, Button, Divider } from '@mui/material';

/**
 * Restricted currency notification body for MDForm CustomModal.
 * Matches legacy rstdCcyModal fragment (title, message, OK).
 */
const YesNoModel = ({
        message = '',
        yesLabel = 'Yes',
        noLabel = 'No',
        onYes,
        onNo,
}) => {
        const handleYes = () => {
                if (onYes) {
                        onYes();
                }
        };
        const handleNo = () => {
                if (onNo) {
                        onNo();
                }
        };
        return (
                <Box id="yesNoMdlFrgmtId" sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box className="modal-body" sx={{ py: 2 }}>
                                <Typography
                                        id="yesNoCnfrmMsg"
                                        component="h6"
                                        variant="subtitle1"
                                        sx={{ color: '#828080', fontWeight: 400, m: 0 }}
                                >
                                        {message}
                                </Typography>
                        </Box>
                        <Divider />
                        <Box className="modal-footer" sx={{ display: 'flex', justifyContent: 'center', gap: 2, py: 2 }}>
                                <Button
                                        type="button"
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        onClick={handleYes}
                                >
                                        {yesLabel}
                                </Button>
                                <Button
                                        type="button"
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        onClick={handleNo}
                                >
                                        {noLabel}
                                </Button>
                        </Box>
                </Box>
        );
};

export default YesNoModel;
